
export default function FormatText() {
  return function(text) {
    return text.replace(/\n/g, '<br/>');
  };
}
